import React from "react";
import closeIcon from "../../../assets/crossIcon.svg";
import arrowIcon from "../../../assets/arrow-right.svg"; // use correct icon

export default function ConfirmRemoveMapping({ open, onClose, onConfirm, loading = false }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-[#00000066] px-4">
      <div className="relative w-full max-w-[1200px] bg-white rounded-[48px] px-16 py-20 text-center">
        {/* Close */}
        <button
          onClick={onClose}
          disabled={loading}
          className="absolute top-12 right-8 bg-transparent border-none p-0 disabled:opacity-60"
        >
          <img src={closeIcon} alt="close" className="w-5 h-5" />
        </button>

        {/* Title */}
        <h2 className="font-lufga font-medium text-[28px] text-[#1F2937]">
          Are you sure, you want to remove the mapping of non-freeze Procedures
          ?
        </h2>

        {/* CTA */}
        <div className="flex items-center justify-center gap-6 mt-16">
          {/* Main Button */}
          <button
            onClick={onConfirm}
            disabled={loading}
            className="w-[420px] h-[96px] rounded-[56px] border border-[#E83D3D] flex items-center justify-center font-lufga font-medium text-[16px] hover:opacity-90 transition disabled:opacity-70 disabled:cursor-not-allowed"
            style={{
              background:
                "linear-gradient(90deg, #E83D3D 0%, rgba(255, 255, 255, 0.5) 50%)",
            }}
          >
            {loading ? "Removing..." : "Yes, Remove Mapping"}
          </button>

          {/* Arrow Button */}
          <button
            onClick={onConfirm}
            disabled={loading}
            className="w-[96px] h-[96px] rounded-full border border-[#E83D3D] flex items-center justify-center disabled:opacity-70 disabled:cursor-not-allowed"
          >
            <img src={arrowIcon} alt="arrow" className="w-6 h-6" />
          </button>
        </div>
      </div>
    </div>
  );
}
